(function () {
    let customShibboleth = {
        init() {
            customShibboleth.addEventListeners();
        },
        addEventListeners() {
            document.querySelector('#learnMorePopup .close').addEventListener('click', function () {
                UX.dropBlock.on.hide();
            });
        },
    };
    UX.customShibboleth = customShibboleth;
})();
